import PageCenterContainer from "./PageCenterContainer";

export default PageCenterContainer;
